// KPI_RISK_INDEX.jsx

export const KPI_RISK_INDEX = ({ processedDashboardData, targetOperationalRisk, theme }) => {
    return (
        <div style={{
                background: theme === 'light' ? '#fff' : '#333',
                padding: '20px',
                borderRadius: '12px',
                boxShadow: '0 6px 12px rgba(0,0,0,0.08)',
                border: '1px solid ' + (theme === 'light' ? '#e0e0e0' : '#555'),
                position: 'relative',
                overflow: 'hidden'
            }}>
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '4px',
                height: '100%',
                background: (processedDashboardData?.outstandingIssues?.total || 0) < targetOperationalRisk ? '#28a745' : 
                            (processedDashboardData?.outstandingIssues?.total || 0) <= (targetOperationalRisk * 2) ? '#ffc107' : '#dc3545'
            }}></div>
            
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '20px' }}>
                <div>
                    <h4 style={{ color: '#6c757d', fontSize: '14px', fontWeight: '600', textTransform: 'uppercase', margin: '0 0 6px 0', letterSpacing: '0.5px' }}>
                        OPERATIONAL RISK INDEX
                    </h4>
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
                        <span style={{ 
                            fontSize: '36px', 
                            fontWeight: 'bold', 
                            color: (processedDashboardData?.outstandingIssues?.total || 0) < targetOperationalRisk ? '#28a745' : 
                                    (processedDashboardData?.outstandingIssues?.total || 0) <= (targetOperationalRisk * 2) ? '#ffc107' : '#dc3545',
                            lineHeight: '1'
                        }}>
                            {processedDashboardData?.outstandingIssues?.total || 0}
                        </span>
                        <span style={{
                            fontSize: '14px',
                            color: (processedDashboardData?.outstandingIssues?.total || 0) < targetOperationalRisk ? '#28a745' : 
                                    (processedDashboardData?.outstandingIssues?.total || 0) <= (targetOperationalRisk * 2) ? '#ffc107' : '#dc3545',
                            fontWeight: '600',
                            textTransform: 'uppercase'
                        }}>
                            {(processedDashboardData?.outstandingIssues?.total || 0) < targetOperationalRisk ? 'GOOD' : 
                                (processedDashboardData?.outstandingIssues?.total || 0) <= (targetOperationalRisk * 2) ? 'MED' : 'HIGH'}
                        </span>
                    </div>
                </div>
                <div style={{
                    background: (processedDashboardData?.outstandingIssues?.total || 0) < targetOperationalRisk ? 'rgba(40, 167, 69, 0.1)' : 
                                (processedDashboardData?.outstandingIssues?.total || 0) <= (targetOperationalRisk * 2) ? 'rgba(255, 193, 7, 0.1)' : 'rgba(220, 53, 69, 0.1)',
                    padding: '8px',
                    borderRadius: '8px',
                    fontSize: '18px'
                }}>
                    📊
                </div>
            </div>
            
            <div style={{ 
                fontSize: '14px', 
                color: theme === 'light' ? '#6c757d' : '#adb5bd',
                marginBottom: '12px'
            }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                    <span>Services:</span><span>{processedDashboardData?.outstandingIssues?.breakdown?.overdue_services || 0}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                    <span>Defects:</span><span>{processedDashboardData?.outstandingIssues?.breakdown?.outstanding_defects || 0}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span>Tacho:</span><span>{processedDashboardData?.outstandingIssues?.breakdown?.unsigned_tacho || 0}</span>
                </div>
            </div>
            
            <div style={{ 
                fontSize: '12px', 
                color: (processedDashboardData?.outstandingIssues?.total || 0) < targetOperationalRisk ? '#28a745' : 
                        (processedDashboardData?.outstandingIssues?.total || 0) <= (targetOperationalRisk * 2) ? '#ffc107' : '#dc3545',
                fontWeight: '600',
                textTransform: 'uppercase'
            }}>
                Target: &lt;{targetOperationalRisk} • {(processedDashboardData?.outstandingIssues?.total || 0) < targetOperationalRisk ? 'OPTIMAL' : 'NEEDS ATTENTION'}
            </div>
        </div>
    )
}